import React, { useEffect, useState } from 'react'

import { Col, Form, Input, Modal, Pagination, Row, Table } from 'antd'

import dayjs from 'dayjs'
import { useRecoilState } from 'recoil'
import customerApi from '../../api/customer.api'
import { userState } from '../../store/user'
import styles from '../../styles/customer.module.scss'

const CrmDetailComponent = ({ crm, handleModalCancel, getCrmHistoryList }) => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)

  const [selectedRowKey, setSelectedRowKey] = useState([])
  const [selectedRow, setSelectedRow] = useState([])
  const [clickRow, setClickRow] = useState(null)
  const [sentList, setSentList] = useState([])
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [totalSentList, setTotalSentList] = useState([])
  const [cancelModal, setCancelModal] = useState(false)
  const [cancelReason, setCancelReason] = useState(null)

  useEffect(() => {
    if (crm && crm.hasOwnProperty('crmHistoryList')) {
      setTotalSentList(crm.crmHistoryList)
      setSentList(crm.crmHistoryList.slice(0, 10))
      setClickRow(crm.crmHistoryList[0])
    }
  }, [crm])

  useEffect(() => {
    setSentList(totalSentList.slice(offset, offset + pageSize))
  }, [offset, pageSize])

  useEffect(() => {
    handleChangePagination(currentPageNumber)
  }, [pageSize])

  useEffect(() => {
    if (totalSentList?.length !== 0) {
      setSentList(totalSentList.slice(0, 10))
    } else {
      setSentList([])
    }
  }, [totalSentList])

  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onSelect: (record, selected) => {
      let editKeyList = []
      let editRowList = []
      if (selected) {
        const filterList = sentList?.filter((item) => item.id === record.id)
        const filterKeyList = filterList.map((row) => row.id)
        editRowList = [...selectedRow, ...filterList]
        editKeyList = [...selectedRowKey, ...filterKeyList]
      } else {
        editRowList = selectedRow.filter((item) => item.id !== record.id)
        editKeyList = editRowList.map((row) => row.id)
      }
      setSelectedRowKey(editKeyList)
      setSelectedRow(editRowList)
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      if (selected) {
        setSelectedRow(selectedRows)
        setSelectedRowKey(selectedRows.map((row) => row.id))
      } else {
        setSelectedRow(selectedRows)
        setSelectedRowKey(selectedRows)
      }
    },
  }

  const columns = [
    {
      title: '발송시간',
      width: 100,
      dataIndex: 'crmSendDate',
      key: 'crmSendDate',
      // ellipsis: true
      render: (value, record) => {
        if (value) {
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <span>{dayjs(value).format('YYYY.MM.DD')}</span>
              <span className={`gray-font`}>
                {dayjs(value).format('HH:mm:ss')}
              </span>
            </div>
          )
        } else {
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <span>{dayjs(record.updatedAt).format('YYYY.MM.DD')}</span>
              <span className={`gray-font`}>
                {dayjs(record.updatedAt).format('HH:mm:ss')}
              </span>
            </div>
          )
        }
      },
    },
    {
      title: '수신자명',
      // width: 210,
      dataIndex: 'targetName',
      key: 'targetName',
      // ellipsis: true
      render: (value) => {
        if (value) {
          return <span className={`ellipse-font`}>{value}</span>
        }
      },
    },
    {
      title: '수신 번호',
      // width: 210,
      dataIndex: 'targetPhone',
      key: 'targetPhone',
      // ellipsis: true
      render: (value) => {
        if (value) {
          return <span className={`ellipse-font`}>{value}</span>
        }
      },
    },
    {
      title: '발송결과',
      // width: 120,
      dataIndex: 'crmIsSend',
      key: 'crmIsSend',
      // ellipsis: true
      render: (value) => {
        switch (value) {
          case 'READY':
            return '예약'
          case 'SUCCESS':
            return '성공'
          case 'FAIL':
            return <span style={{ color: '#fe2b4b' }}>실패</span>
          case 'RESERVATION':
            return <span style={{ color: '#ff8000' }}>대기</span>
          case 'CANCEL':
            return '취소'
          default:
            return ''
        }
      },
    },
    {
      title: '실패사유',
      // width: 120,
      dataIndex: 'sendFailReason',
      key: 'sendFailReason',
      // ellipsis: true
    },
    // {
    //   title: '취소사유',
    //   // width: 120,
    //   dataIndex: 'send_cancel_reason',
    //   key: 'send_cancel_reason',
    //   // ellipsis: true
    // },
  ]

  const changeCrmTypeText = () => {
    let sendType = '기타'
    if (crm.templateTitle) {
      if (crm.templateTitle.includes('ORDER_DEPOSIT_REQUEST')) {
        sendType = `무통장 입금대기 ${crm.templateTitle.replace(
          'ORDER_DEPOSIT_REQUEST_',
          '',
        )}일차`
      } else if (crm.templateTitle.includes('VIRTUAL_ACCOUNT_REQUEST')) {
        sendType = `가상계좌 입금대기 ${crm.templateTitle.replace(
          'VIRTUAL_ACCOUNT_REQUEST_',
          '',
        )}일차`
      } else {
        sendType = crm?.templateTitle
      }
    }
    return sendType
  }

  /**
   * CRM 목록 선택
   */
  const handleRowEvent = (record) => {
    return {
      onClick: (_) => {
        setClickRow(record)
      },
    }
  }

  /**
   * 예약건 발송처리 click handler (2023.03.20) - ksb
   */
  const handleSendClick = async () => {
    if (
      window.confirm(
        `${selectedRow[0]?.targetName}님${
          selectedRow?.length > 1
            ? ` 외 ${selectedRow?.length - 1}건을`
            : '에게'
        } CRM을 전송하시겠습니까?\n"확인"을 누를시, 최대 5분 이내에 자동으로 전송됩니다.`,
      )
    ) {
      setIsLoading(true)
      try {
        const param = {
          crmIdList: selectedRow.map((row) => row.id),
        }
        const res = await customerApi.changeCRMListToWait(param, user.id)
        if (res.data.code === 200) {
          alert(
            `총 ${res.data.result}건 발송 예약 처리되었습니다.\n5분 이후에 확인해주세요!`,
          )
          handleModalCancel()
          getCrmHistoryList()
        } else {
          throw res.data.msg
        }
        setIsLoading(false)
      } catch (e) {
        setIsLoading(false)
        alert(e)
      }
    }
  }

  /**
   * 취소사유작성 Modal cancel handler (2023.03.22) - ksb
   */
  const handleCancelReasonModalClick = () => {
    if (cancelReason) {
      if (
        window.confirm('작성중이던 내용이 존재합니다. 그래도 취소하시겠습니까?')
      ) {
        setCancelModal(false)
        setCancelReason(null)
      }
    } else {
      setCancelModal(false)
    }
  }

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(currOffset)
  }

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
    setOffset((current - 1) * pageSize)
  }

  /**
   * 발송버튼 disabled 처리 (2023.03.22) - ksb
   */
  const disabledSendBtn = () => {
    if (selectedRow?.length === 0) {
      return true
    } else if (selectedRow.every((row) => row.crm_is_send === 3)) {
      return false
    } else {
      return true
    }
  }

  /**
   * 발송 취소버튼 disabled 처리 (2023.03.22) - ksb
   */
  const disabledCancelBtn = () => {
    if (selectedRow?.length === 0) {
      return true
    } else if (
      selectedRow.every(
        (row) => row.crmIsSend === 'RESERVATION' || row.crmIsSend === 'READY',
      )
    ) {
      return false
    } else {
      return true
    }
  }

  return (
    <>
      <Row
        align="stretch"
        wrap={false}
        className={`${styles['crm-detail-body']}`}
        style={{ rowGap: '1rem', gap: '1rem' }}
      >
        <Col md={10}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              className="order-detail-modal-subtitle"
              style={{
                margin: 0,
                display: 'flex',
                gap: '5px',
                alignItems: 'center',
              }}
            >
              {crm.totalCnt > 1 ? '대량발송' : '단건발송'}
              <span
                className={`gray-font`}
                style={{
                  fontSize: '20px',
                }}
              >
                ({changeCrmTypeText()})
              </span>
            </div>
            <p style={{ fontSize: '1.2rem' }}>
              총 : {crm.totalCnt} / 성공 : {crm.successCnt} / 실패 :&nbsp;
              <span
                style={{
                  color: '#fe2b4b',
                }}
              >
                {crm.failCnt}
              </span>
              &nbsp;/ 대기 :&nbsp;
              <span
                style={{
                  color: '#ff8000',
                }}
              >
                {crm.reservationCnt}
              </span>
            </p>
          </div>
          <h5>내용</h5>
          <div className={`${styles['crm-content-div']}`}>
            <p>{clickRow?.crmMessage}</p>
          </div>
        </Col>
        <Col md={14}>
          {crm &&
            totalSentList?.length > 0 &&
            (crm.reservationCnt > 0 ||
              totalSentList.some((crm) => crm.crmIsSend === 'READY')) && (
              <Row
                justify="end"
                align="middle"
                wrap={false}
                style={{ gap: '10px', marginBottom: '10px' }}
              >
                {crm.reservationCnt > 0 && (
                  <button
                    className={`${styles['crm-send-btn']}`}
                    disabled={disabledSendBtn()}
                    onClick={(e) => {
                      e.stopPropagation()
                      handleSendClick()
                    }}
                  >
                    발송
                  </button>
                )}
                {/*<button*/}
                {/*    className="crm-cancel-btn"*/}
                {/*    onClick={() => setCancelModal(true)}*/}
                {/*    disabled={disabledCancelBtn()}*/}
                {/*>취소</button>*/}
              </Row>
            )}
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={sentList}
            // loading={isLoading}
            bordered
            size="middle"
            rowKey="id"
            className={`${styles['table-class']}`}
            rowClassName="coupon-table-row"
            // scroll={{y: 'calc(191px - 48px)'}}
            onRow={handleRowEvent}
            // onChange={tableOnChange}
            tableLayout="auto"
            pagination={false}
          />
          <Pagination
            showSizeChanger
            pageSize={pageSize}
            onShowSizeChange={pageSizeChange}
            total={totalSentList?.length}
            onChange={handleChangePagination}
            align={'end'}
            style={{ marginTop: 20 }}
            current={currentPageNumber}
          />
        </Col>
      </Row>
      {cancelModal && (
        <Modal
          title="취소사유"
          wrapClassName="order-detail-modal-wrap"
          open={cancelModal}
          centered={true}
          onCancel={handleCancelReasonModalClick}
          footer={null}
          width="40%"
        >
          <p>총 {selectedRow?.length}건을 취소처리 진행합니다.</p>
          <Form.Item
            className="center-label"
            label="취소사유"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Input
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
            />
          </Form.Item>
          <button>확인</button>
        </Modal>
      )}
    </>
  )
}
export default CrmDetailComponent
